import React, { useEffect } from "react";
import { useDashboardStore } from "../../../store/dashboardStore.js";


import PrimaryButton from "../../button/primarybutton";

import PendingItemBox from "./pendingitembox";

import Loader from "../../loader/loader";
import images from "../../../assets";

const PendingItems = () => {
  const { pendingItems, isPendingLoading, getPendingItems } =
    useDashboardStore();

  useEffect(() => {
    fetchPendingItems();
  }, []);

  const fetchPendingItems = async () => {
    getPendingItems();
  };

  return (
    <>
      <div
        style={{
          backgroundImage: "url(" + images.pendingitemBg + ")",
          backgroundPosition: "100% 100%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="w-full px-16 py-6 rounded-2xl flex-col justify-center items-start gap-2.5 inline-flex"
      >
        {isPendingLoading ? (
          <Loader />
        ) : (
          <div className="self-stretch flex-col justify-start items-center gap-4 flex">
            <h2 className="text-[#ffffff] text-3xl font-semibold  leading-9">
              Pending Items
            </h2>
            <div className="flex self-stretch justify-center items-center gap-8 flex-col lg:flex-row">
              <PendingItemBox
                title="Photos"
                pendingcount={pendingItems?.pendingImages}
              >
                <PrimaryButton
                  style={{
                    height: "32px",
                    width: "112px",
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                  text={"Review"}
                  iconalign="left"
                  icon={images.hyperlinkIcon}
                />
              </PendingItemBox>
              <PendingItemBox
                title="Profile Description"
                pendingcount={pendingItems?.profileDescriptionPending}
              >
                <PrimaryButton
                  style={{
                    height: "32px",
                    width: "112px",
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                  text={"Review"}
                  iconalign="left"
                  icon={images.hyperlinkIcon}
                />
              </PendingItemBox>
              <PendingItemBox
                title="Match Description"
                pendingcount={pendingItems?.matchPreferencePending}
              >
                <PrimaryButton
                  style={{
                    height: "32px",
                    width: "112px",
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                  text={"Review"}
                  iconalign="left"
                  icon={images.hyperlinkIcon}
                />
              </PendingItemBox>
              <PendingItemBox
                title="Trust Badge"
                pendingcount={pendingItems?.trustbadgePending}
              >
                <PrimaryButton
                  style={{
                    height: "32px",
                    width: "112px",
                    fontSize: "16px",
                    fontWeight: 500,
                  }}
                  text={"Review"}
                  iconalign="left"
                  icon={images.hyperlinkIcon}
                />
              </PendingItemBox>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default PendingItems;








